<template>
    <v-card>
        <v-container fluid>
            <v-layout row wrap>
                <v-flex xs12>
                    <div class="loader"></div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>
<script>
export default {}
</script>